import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    team:{
      zhiweiindex:0,
      zhiweilmid:13,
      chengshilmid:'',
      page:1
    }
  },
  mutations: {
    setVuex(state,obj){
      Object.keys(obj).forEach(item => state.team[item] = obj[item])
    }
  },
  actions: {

  }
})
